type EmployeeChangeLogSource = 'MANUAL' | 'QUICKBOOKS' | 'MERGE_DEV' | 'DIRECTORY_IMPORT';

export const EMPLOYEE_CHANGE_LOG_CHANGE_TYPE = {
  CREATE: 'CREATE',
  ARCHIVE: 'ARCHIVE',
  UPDATE: 'UPDATE',
  MERGE: 'MERGE',
  CREATED_IN_HRIS: 'CREATED_IN_HRIS',
} as const;

export type EmployeeChangeLogChangeType = ValueOf<typeof EMPLOYEE_CHANGE_LOG_CHANGE_TYPE>;

export type EmployeeChangeLog = {
  employeeChangeLogId: number;
  employeeId: number;
  username?: string | null;
  source: EmployeeChangeLogSource;
  changeType: EmployeeChangeLogChangeType;
  updatedAt?: Date | null;

  // EmployeeChangeLog json updatedFields flattened out to the information we want to display to users
  employeeChanges?: EmployeeChangeLogUpdatedFields;
  personChanges?: PersonChangeLogUpdatedFields | null;
  groupChanges?: UpdatedField<Array<number>>;
  supervisorChanges?: UpdatedField<Array<number>>;
  subordinateChanges?: UpdatedField<Array<number>>;
};

export type UpdatedField<T> = {
  newValue: T;
  oldValue: T;
};

export type EmployeeChangeLogUpdatedFields = {
  employeeId?: UpdatedField<number>;
  orgId?: UpdatedField<number>;
  contactId?: UpdatedField<number>;
  personId?: UpdatedField<number>;
  username?: UpdatedField<string | null | undefined>;
  jobApplicantId?: UpdatedField<(string | number) | null | undefined>;
  employeeHash?: UpdatedField<string | null | undefined>;

  jobTitle?: UpdatedField<string | null | undefined>;
  startDate?: UpdatedField<Date | null | undefined>;
  nickname?: UpdatedField<string | null | undefined>;
  isCurrentEmployee?: UpdatedField<boolean | null | undefined>;
  endDate?: UpdatedField<Date | null | undefined>;
  integrationId?: UpdatedField<string | null | undefined>;
  hasNoSupervisor?: UpdatedField<boolean | null | undefined>;
  deletedAt?: UpdatedField<Date | null | undefined>;
  optedOutOfTexts?: UpdatedField<boolean | null | undefined>;
  manuallyOptedOutDate?: UpdatedField<Date | null | undefined>;
  endReasonId?: UpdatedField<number | null | undefined>;
  endReasonExplanation?: UpdatedField<string | null | undefined>;
};

export type PersonChangeLogUpdatedFields = {
  person_id?: UpdatedField<number | null | undefined>;
  firstName?: UpdatedField<string>;
  lastName?: UpdatedField<string>;
  email?: UpdatedField<string | null | undefined>;
  phoneNumber?: UpdatedField<string | null | undefined>;
  birthdate?: UpdatedField<Date | null | undefined>;
  languagePreference?: UpdatedField<string | null | undefined>;
};
